module.exports = __webpack_public_path__ + "img/dcpoint.7bd0e395.png";